import React from 'react';
export const TextButton = ({ children, className, onClick, dataTestId, }) => {
    const defaultClasses = 'sui-antialiased sui-font-regular sui-text-base sui-tracking-normal sui-normal-case sui-text-primary sui-line-clamp-none sui-text-primary sui-underline focus-visible:sui-bg-focus focus-visible:sui-outline-0';
    return (React.createElement("button", { type: "button", onClick: onClick, className: `${defaultClasses} ${className}`, "data-testid": dataTestId }, children));
};
